export default "__VITE_ASSET__nTNwrVoK__"